namespace AgerLMS.WebSite {

    export interface ContactPageWidgetRequest {
        Fullname?: string;
        Email?: string;
        Phone?: string;
        Subject?: string;
        Message?: string;
    }

    @Serenity.Decorators.registerClass()
    export class ContactPageWidget extends Serenity.Widget<ContactPageWidgetRequest> {

        button : string = "#ContactPageForm";
        formSelector : string = "#ContactPageForm";

        constructor(element: JQuery, opt: ContactPageWidgetRequest) {
            super(element, opt);

            this.bindValidate();

            $(this.button).click(e => {
                e.preventDefault();

                if (!$(this.formSelector).valid()) return;

                let request = <ContactPageWidgetRequest>{};
                request.Fullname = $("input#fullname").val();
                request.Email = $("input#email").val();
                request.Phone = $("input#phone").val();
                request.Subject = $("input#subject").val();
                request.Message = $("textarea#message").val();

                SweetAlert.swal_success("oh my god", "oh my god");

                this.clearForm();

                // Q.serviceCall({
                //     url: Q.resolveUrl('~/Account/ContactPage'),
                //     request: request,
                //     onSuccess: response => {
                //         //this.redirectToReturnUrl(request.Username);
                //     },
                //     onError: (response: Serenity.ServiceResponse) => {
                //         SweetAlert.swal_alert(response.Error.Message, response.Error.Message)
                //     }
                //     // onError: (response: Serenity.ServiceResponse) => {
                //     //     if (response != null && response.Error != null && response.Error.Code == "TwoFactorAuthenticationRequired") {
                //     //         var args = response.Error.Arguments.split('|');
                //     //         this.handleTwoFactorAuthentication(request.Username, request.Password, args[1], args[0]);
                //     //         return;
                //     //     }

                //     //     if (response != null && response.Error != null && response.Error.Code == "RedirectUserTo") {
                //     //         window.location.href = response.Error.Arguments;
                //     //         return;
                //     //     }

                //     //     if (response != null && response.Error != null && !Q.isEmptyOrNull(response.Error.Message)) {
                //     //         Q.notifyError(response.Error.Message);
                //     //         $('#Password').focus();

                //     //         return;
                //     //     }

                //     //     Q.ErrorHandling.showServiceError(response.Error);
                //     // }
                // });
            });

            $(document).keypress(function(e){
                if (e.which == 13){
                    $(this.button).click();
                }
            });
        }

        private clearForm() {
            $("input#fullname").val("");
            $("input#email").val("");
            $("input#phone").val("");
            $("input#subject").val("");
            $("textarea#message").val("");
        }

        private bindValidate() {
            var self = this;
            
            $.validator.addMethod('trPhone', function(value, element) {
                return value.match(/05[0-9]{8}/);
            },"Geçerli telefon numarası girin.");

            $("#ContactPageForm").validate({
                errorClass: "is-invalid",
                rules: {
                    fullname: "required",
                    email: {
                        required: true,
                        email: true
                    },
                    phone: { required : true, trPhone : true, minlength: 11, maxlength: 11 },   
                    subject: { required : true, minlength: 10, maxlength: 100 } ,
                    message: { required : true, minlength: 50, maxlength: 500 }     
                },
                messages: {
                    fullname: "* Lütfen adınızı belirtin.",
                    email: {
                        required: "* Sizinle iletişim kurmak için e-posta adresinize ihtiyacımız var!",
                        email: "* E-posta adresiniz mail@xxx.xxx biçiminde olmalıdır!"
                    },
                    phone: {
                        required: "* Sizinle iletişim kurmak için cep telefonunuz gereklidir!. 05XXXXXXXXX",
                        trPhone: "* Geçerli bir cep telefonu numarası girin!",
                        minlength : "* Geçerli bir cep telefonu numarası girin!.",
                        maxlength: "* Geçerli bir cep telefonu numarası girin!."
                    },
                    subject: {
                        required: "* Lütfen konu girin.",
                        minlength : "* Konu en az 10 karakter olmalıdır.",
                        maxlength: "* Konu en fazla 100 karakter olmalıdır."
                    },
                    message: {
                        required: "* Lütfen mesaj girin.",
                        minlength : "* Mesajınız en az 50 karakter olmalıdır.",
                        maxlength: "* Mesajınız en fazla 500 karakter olmalıdır."
                    }
                }
            });
        }

        protected redirectToReturnUrl(username : string) {
            var q = Q.parseQueryString();
            var returnUrl = q['returnUrl'] || q['ReturnUrl'];
            if (returnUrl) {
                var hash = window.location.hash;
                if (hash != null && hash != '#')
                    returnUrl += hash;
                window.location.href = returnUrl;
            }
            else {
                window.location.href = Q.resolveUrl('~/panel');
            }
        }
    }
}